import { Component, computed } from '@angular/core';
import { environment } from '@core/environments/environment';
import { EEnvironmentName } from '@core/environments/environment.defaults';

@Component({
  selector: 'app-env-badge',
  template: `
    @if (showBadge()) {
      <div
        class="fixed top-0 left-0 bg-shikenso-error-base text-shikenso-base-white text-[8px] leading-[10px] text-center vertical-middle font-bold px-1 pb-0 pt-[1px] z-[9999] rounded-br-sm"
      >
        {{ environment.environmentName }}
      </div>
    }
  `,
})
export class EnvBadgeComponent {
  public readonly environment = environment;

  public readonly showBadge = computed((): boolean => {
    return (
      !this.environment.production &&
      !!this.environment.environmentName &&
      this.environment.environmentName !== EEnvironmentName.production
    );
  });
}
